import styled from 'styled-components';

export const Navigation = styled.div`
  display: flex;
  max-height: 100%;
  place-content: center space-between;
  align-items: center;
  width: 100%;
`;
